module.exports = __webpack_public_path__ + "img/ducky.452e2ec8.png";